import { PropTypes } from 'prop-types'
import React from 'react'
import './buttonLinkCtaList.css'
import DOMPurify from 'dompurify'
const LINK_TYPES = {
  PRIMARY_BTN: 'primaryBtn',
  BRAND_PRIMARY_BTN: 'brandPrimaryBtn',
  RASPBERRY_PRIMARY_BTN: 'raspberryPrimaryBtn',
  AQUA_PRIMARY_BTN: 'aquaPrimaryBtn',
  YELLOW_PRIMARY_BTN: 'yellowPrimaryBtn',
  SECONDARY_BTN: 'secondaryBtn',
  TERTIARY_BTN: 'tertiaryBtn',
  LINK: 'link',
  LINK_WITH_ARROW: 'linkWithArrow',
}

const LINK_DISPLAY_TYPES = {
  INLINE: 'inline',
  BLOCK: 'block',
}

const LINK_WIDTH_TYPES = {
  AUTO: 'auto',
  FULL: 'full',
}

const ButtonLinkCtaList = ({ linkList = [] }) => {
  const getStyles = (type, reversed) => {
    const linkReversed = reversed ? 'Link--reversed' : ''
    const buttonReversed = reversed ? 'Button--reversed' : ''

    switch (type) {
      case LINK_TYPES.PRIMARY_BTN:
        return `Button Button--primary ${buttonReversed}`
      case LINK_TYPES.BRAND_PRIMARY_BTN:
        return `Button Button--primary Button--color--brand ${buttonReversed}`
      case LINK_TYPES.RASPBERRY_PRIMARY_BTN:
        return `Button Button--primary Button--color--raspberry ${buttonReversed}`
      case LINK_TYPES.AQUA_PRIMARY_BTN:
        return `Button Button--primary Button--color--aqua ${buttonReversed}`
      case LINK_TYPES.YELLOW_PRIMARY_BTN:
        return `Button Button--primary Button--color--yellow ${buttonReversed}`
      case LINK_TYPES.SECONDARY_BTN:
        return `Button Button--secondary ${buttonReversed}`
      case LINK_TYPES.TERTIARY_BTN:
        return `Button Button--tertiary ${buttonReversed}`
      case LINK_TYPES.LINK:
        return `Link u-posRelative hover-underline-animation ${linkReversed}`
      case LINK_TYPES.LINK_WITH_ARROW:
        return `Link u-posRelative hover-underline-animation ${linkReversed}`
      default:
        return `Link u-posRelative hover-underline-animation ${linkReversed}`
    }
  }

  const getDisplayStyle = (display) => {
    switch (display) {
      case LINK_DISPLAY_TYPES.BLOCK:
        return 'flex'
      case LINK_DISPLAY_TYPES.INLINE:
      default:
        return 'inline-block'
    }
  }

  const getWidthStyle = (width) => {
    switch (width) {
      case LINK_WIDTH_TYPES.FULL:
        return '100%'
      case LINK_WIDTH_TYPES.AUTO:
      default:
        return 'auto'
    }
  }

  const isLink = (type) => {
    return [LINK_TYPES.LINK, LINK_TYPES.LINK_WITH_ARROW].includes(type)
  }

  const handleBtnClick = (link) => {
    if (link?.url) {
      if (link?.target === '_blank') {
        window.open(link.url, '_blank')
      } else {
        window.location.href = DOMPurify.sanitize(link.url)
      }
    }
  }

  return (
    <>
      {linkList?.length > 0 ? (
        <div className="buttonLinkCtaList">
          {linkList?.map((link = {}, index) => {
            const displayStyle = getDisplayStyle(link?.display)
            const widthStyle = getWidthStyle(link?.width)
            return (
              <div
                key={index}
                className="cta-list-item"
                style={{
                  display: displayStyle,
                  width: widthStyle,
                }}
              >
                {isLink(link?.type) ? (
                  <a
                    href={DOMPurify.sanitize(link?.url)}
                    target={link?.target}
                    data-analytics={link?.analyticsAttribute}
                    style={{
                      width: widthStyle,
                    }}
                    className={`u-flex flex-row u-flexJustifyCenter ${getStyles(link?.type, link?.reversed)}`}
                  >
                    {link?.text}

                    {link?.type === LINK_TYPES.LINK_WITH_ARROW && (
                      <span className={`arrow Icon--material`}>
                        navigate_next
                      </span>
                    )}
                  </a>
                ) : (
                  <button
                    href={DOMPurify.sanitize(link?.url)}
                    target={link?.target}
                    data-analytics={link?.analyticsAttribute}
                    style={{
                      width: widthStyle,
                    }}
                    className={`u-flex flex-row u-flexJustifyCenter ${getStyles(link?.type, link?.reversed)}`}
                    onClick={() => handleBtnClick(link)}
                  >
                    {link?.text}
                  </button>
                )}
              </div>
            )
          })}
        </div>
      ) : (
        ''
      )}
    </>
  )
}

ButtonLinkCtaList.propTypes = {
  linkList: PropTypes.array,
}

export default ButtonLinkCtaList
